import React from 'react';
import { Button, Toolbar } from '@ui';
/**
 * Static (never floating) bulk-action toolbar — rendered outside `Table`, per E2E-06. `Table`'s
 * own `toolbar`/`selection` config floats its mass toolbar the moment a row is selected
 * (`Table.tsx` passes `anchorElement={firstSelectedAnchor ?? undefined}`), so this component must
 * not use either prop.
 *
 * Selection chrome and Delete are universal, so they live here; everything else a surface wants in
 * this toolbar arrives as `children` from its own config, with its own endpoints and copy.
 */
export function AttachmentsToolbar({ selectedCount, selectedLabel, selectAllLabel, onSelectAll, clearSelectionLabel, onClearSelection, deleteLabel, disabled, onRequestDelete, children }) {
    return (React.createElement(Toolbar, null,
        React.createElement(Toolbar.Selection, { count: selectedCount, selectedLabel: selectedLabel, selectMatchingLabel: selectAllLabel, onSelectMatching: onSelectAll, clearLabel: clearSelectionLabel, onClear: onClearSelection }),
        React.createElement(Toolbar.Group, null,
            children,
            React.createElement(Button, { disabled: disabled, onClick: onRequestDelete },
                React.createElement("i", { className: "fa-light fa-trash", "aria-hidden": "true" }),
                " ",
                deleteLabel))));
}
